import submitCommand from '../../../services/submitCommand';

export const deleteSectionCustomization = (
  customizationId: string,
  timelineId: string,
  orgId: string,
  sectionId: string,
  segmentId: string,
  initiatingUserId: string
) => {
  return submitCommand(
    customizationId,
    {
      customizationID: customizationId,
      timelineID: timelineId,
      orgID: { id: orgId },
      segmentID: segmentId,
      sectionID: sectionId,
      initiatingUserID: initiatingUserId,
    },
    'TcDeleteSectionCustomization',
    'TcSectionCustomizationDeleted',
    'TcSectionCustomizationFailed'
  );
};
